import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/home'
import Test from '@/pages/home/test'
import Login from '@/pages/login'
import Profile from '@/pages/profile'
import InsureList from '@/pages/insure/list'
import Verify from '@/pages/insure/verify'
import Index from '@/pages/index'
import Register from '@/pages/login/register'

// 球队管理
import Manage from '@/pages/team/manage'
import Setting from '@/pages/team/setting/index'
import SettingMatch from '@/pages/team/setting/match'
import SettingPlayer from '@/pages/team/setting/player/info'
import Participate from '@/pages/team/participate/index'
import ParticipateMatchTeamList from '@/pages/team/participate/team-list'
import ParticipateMatchTeamInfo from '@/pages/team/participate/team-info'
import ParticipatePlayerApply from '@/pages/team/participate/player-apply'
import ParticipatePlayerInfo from '@/pages/team/participate/player-info'
import ParticipatePlayerEdit from '@/pages/team/participate/player-edit'
import ParticipateMatchTeamDetailed from '@/pages/team/participate/team-detailed'
import ParticipateMatchTeamPlayerDetailed from '@/pages/team/participate/player/player-detailed'
import ParticipateMatchTeamOfficerDetailed from '@/pages/team/participate/player/officer-edit'
import ParticipateMatchTeamPlayerPermit from '@/pages/team/participate/player/permit'
import ParticipatePlayer from '@/pages/team/participate/player/index'
import UploadFile from '@/pages/upload-file/index'
import SignUp from '@/pages/team/sign-up/index'
import SignUpList from '@/pages/team/sign-up/list'
import SignUpDetailed from '@/pages/team/sign-up/detailed'
import Invite from '@/pages/invite/index'
import Invitation from '@/pages/invite/invitation'
import InviteTeam from '@/pages/invite/team'
import InviteApplyFor from '@/pages/invite/apply-for'
import ApplyDone from '@/pages/invite/apply-done'
import InviteCreate from '@/pages/invite/create'
import CreateTeam from '@/pages/create/'
import Introduction from '@/pages/introduction/'
import IntroductionMatch from '@/pages/introduction/match'
import IntroductionTeam from '@/pages/introduction/team'

import InviteTeamEdit from '@/pages/invite-team'
import InviteTeamEditInfo from '@/pages/invite-team/info'
import InviteTeamCaptain from '@/pages/invite-team/captain'
import InviteTeamCaptainPlayerList from '@/pages/invite-team/captain/player-list'
import InviteTeamCaptainPlayerAdd from '@/pages/invite-team/captain/player-add'
import InviteTeamUser from '@/pages/invite-team/user/'
import InviteTeamClaim from '@/pages/invite-team/user/claim'
import InviteTeamReplace from '@/pages/invite-team/user/replace'

import InvitePlayer from '@/pages/invite-player/index'

import Buy from '@/pages/buy/index'
import BuyLiveGame from '@/pages/buy/live-game'

import CustomerService from '@/pages/customer-service/'
import CustomerServiceList from '@/pages/customer-service/list'
import CustomerServiceDet from '@/pages/customer-service/det'
import BDAgent from '@/pages/customer-service/bd-agent'
import BDAgent2 from '@/pages/customer-service/bd-agent2'
import PriceNotice from '@/pages/customer-service/price-notice'

import GroupBuy from '@/pages/ad-server/group-buy'

import ErrorPage from '@/pages/errorPage/404'

import LiveService from '@/pages/liveService'
import Reservation from '@/pages/reservation'
import LiveScore from '@/pages/live-score'
import teamStats from '@/pages/team-stats'

import OfficialWebsite from '@/pages/official-website'
import OfficialSuccess from '@/pages/official-success'
import OnlineCashInstructions from '@/pages/online-cash-instructions'

// 有镜头
import LiveCut from '@/pages/live-cut'

// 官网--赛事通、邦教练、智慧场馆、体协+
import officialEventLink from '@/pages/official-eventLink'
import officialCoachBond from '@/pages/official-coachBond'
import officialSmartVenues from '@/pages/official-smartVenues'
import officialAthleticAssociation from '@/pages/official-athleticAssociation'
import officialYouth from '@/pages/official-youth'
import serviceContact from '@/pages/service-contact'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      name: 'Home',
      meta: {
        title: '保险服务'
      },
      component: Home
    },
    {
      path: '/test',
      name: 'Test',
      meta: {
        title: '测试bridge接口'
      },
      component: Test
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: '账号登录'
      },
      component: Login
    },
    {
      path: '/register',
      name: 'Register',
      meta: {
        title: '账号注册'
      },
      component: Register
    },
    {
      path: '/profile',
      name: 'Profile',
      meta: {
        title: '个人中心'
      },
      component: Profile
    },
    {
      path: '/insure-list',
      name: 'InsureList',
      meta: {
        title: '保单列表'
      },
      component: InsureList
    },
    {
      path: '/verify',
      name: 'Verify',
      meta: {
        title: '实名认证'
      },
      component: Verify
    },
    {
      path: '/index',
      name: 'Index',
      meta: {
        title: '欢迎首页'
      },
      component: Index
    },
    {
      path: '/team',
      name: 'TeamManage',
      meta: {
        title: '球队管理'
      },
      component: Manage
    },
    {
      path: '/setting',
      name: 'Setting',
      component: Setting,
      redirect: '/setting/match',
      children: [
        {
          path: 'match',
          name: 'SettingMatch',
          component: SettingMatch,
          meta: {
            title: '赛事报名设置'
          }
        },
        {
          path: 'player',
          name: 'SettingPlayer',
          component: SettingPlayer,
          meta: {
            title: '设置球员资料'
          }
        }
      ]
    },
    {
      path: '/participate',
      name: 'Participate',
      component: Participate,
      redirect: '/participate/team-list',
      children: [
        {
          path: 'team-list',
          name: 'TeamList',
          component: ParticipateMatchTeamList,
          meta: {
            title: '参赛球队'
          }
        },
        {
          path: 'team-edit',
          name: 'TeamEdit',
          component: ParticipateMatchTeamDetailed,
          meta: {
            title: '编辑球队'
          }
        },
        {
          path: 'team-info',
          name: 'TeamInfo',
          component: ParticipateMatchTeamInfo,
          meta: {
            title: '参赛球队详情'
          }
        },
        {
          path: 'player-apply',
          name: 'PlayerApply',
          component: ParticipatePlayerApply,
          meta: {
            title: '球员注册报名'
          }
        },
        {
          path: 'player-info',
          name: 'PlayerInfo',
          component: ParticipatePlayerInfo,
          meta: {
            title: '球员报名信息'
          }
        },
        {
          path: 'player-edit',
          name: 'ParticipatePlayerEdit',
          component: ParticipatePlayerEdit,
          meta: {
            title: '编辑球员参赛信息'
          }
        }
      ]
    },
    {
      path: '/player',
      name: 'Player',
      component: ParticipatePlayer,
      redirect: '/player/edit',
      children: [
        {
          path: 'edit',
          name: 'PlayerEdit',
          component: ParticipateMatchTeamPlayerDetailed,
          meta: {
            title: '编辑队员'
          }
        },
        {
          path: 'officer-edit',
          name: 'OfficerEdit',
          component: ParticipateMatchTeamOfficerDetailed,
          meta: {
            title: '编辑球队官员'
          }
        },
        {
          path: 'permit',
          name: 'PlayerPermit',
          component: ParticipateMatchTeamPlayerPermit,
          meta: {
            title: '球员参赛证'
          }
        }
      ]
    },
    {
      path: '/upload-file',
      name: 'UploadFile',
      component: UploadFile,
      meta: {
        title: '文件上传'
      }
    },
    {
      path: '/sign-up',
      name: 'SignUp',
      component: SignUp,
      redirect: '/sign-up/list',
      children: [
        {
          path: 'list',
          name: 'SignUpList',
          component: SignUpList,
          meta: {
            title: '报名球队'
          }
        },
        {
          path: 'edit',
          name: 'SignUpEdit',
          component: SignUpDetailed,
          meta: {
            title: '报名球队详情'
          }
        }
      ]
    },
    {
      path: '/invite',
      name: 'Invite',
      component: Invite,
      redirect: '/invite/invitation',
      children: [
        {
          path: 'invitation',
          name: 'Invitation',
          component: Invitation,
          meta: {
            title: '邀请球队'
          }
        },
        {
          path: 'team',
          name: 'InviteTeam',
          component: InviteTeam,
          meta: {
            title: '赛事邀请报名球队'
          }
        },
        {
          path: 'apply-for',
          name: 'InviteSignUp',
          component: InviteApplyFor,
          meta: {
            title: '赛事报名'
          }
        },
        {
          path: 'apply-done',
          name: 'ApplyDone',
          component: ApplyDone,
          meta: {
            title: '提交审核成功'
          }
        },
        {
          path: 'create',
          name: 'InviteCreateTeam',
          component: InviteCreate,
          meta: {
            title: '创建球队'
          }
        }
      ]
    },
    {
      path: '/introduction',
      name: 'Introduction',
      component: Introduction,
      redirect: '/introduction/match',
      children: [
        {
          path: 'match',
          name: 'IntroductionMatch',
          component: IntroductionMatch,
          meta: {
            title: '导入赛事'
          }
        },
        {
          path: 'team',
          name: 'IntroductionTeam',
          component: IntroductionTeam,
          meta: {
            title: '导入球队'
          }
        }
      ]
    },
    {
      path: '/create',
      name: 'CreateTeam',
      component: CreateTeam,
      meta: {
        title: '创建球队'
      }
    },
    {
      path: '/invite-team-edit',
      name: 'InviteTeamEdit',
      component: InviteTeamEdit,
      redirect: '/invite-team-edit/info',
      children: [
        {
          path: 'info',
          name: 'InviteTeamInfo',
          component: InviteTeamEditInfo,
          meta: {
            title: '编辑球队'
          }
        },
        {
          path: 'captain',
          name: 'InviteTeamCaptain',
          component: InviteTeamCaptain,
          redirect: '/invite-team-edit/captain/player-list',
          children: [
            {
              path: 'player-list',
              name: 'InviteTeamCaptainPlayer',
              component: InviteTeamCaptainPlayerList,
              meta: {
                title: '选择参赛球员'
              }
            },
            {
              path: 'player-add',
              name: 'InviteTeamCaptainPlayerAdd',
              component: InviteTeamCaptainPlayerAdd,
              meta: {
                title: '添加球员'
              }
            }
          ]
        },
        {
          path: 'user',
          name: 'InviteTeamUser',
          component: InviteTeamUser,
          redirect: '/invite-team-edit/user/replace',
          children: [
            {
              path: 'replace',
              name: 'InviteTeamUserReplace',
              component: InviteTeamReplace,
              mate: {
                title: '替换球队'
              }
            },
            {
              path: 'claim',
              name: 'InviteTeamUserClaim',
              component: InviteTeamClaim,
              mate: {
                title: '认领球队'
              }
            }
          ]
        }
      ]
    },
    {
      path: '/invite-player',
      name: 'NamePlayer',
      component: InvitePlayer,
      meta: {
        title: '球员编辑'
      }
    },
    {
      path: '/buy',
      name: 'Buy',
      component: Buy,
      meta: {
        title: '购买场次'
      }
    },
    {
      path: '/buy-live-game',
      name: 'BuyLiveGame',
      component: BuyLiveGame,
      meta: {
        title: '购买信息'
      }
    },
    {
      path: '/customer-service',
      redirect: '/customer-service/list',
      name: 'CustomerService',
      component: CustomerService,
      children: [
        {
          path: 'list',
          name: 'CustomerServiceList',
          component: CustomerServiceList,
          meta: {
            title: '咨询解答列表'
          }
        },
        {
          path: 'det',
          name: 'CustomerServiceDet',
          component: CustomerServiceDet,
          meta: {
            title: '咨询解答详情'
          }
        },
        {
          path: 'bd-agent',
          name: 'BDAgent',
          component: BDAgent,
          meta: {
            title: '赛事管家'
          }
        },
        {
          path: 'bd-agent2',
          name: 'BDAgent2',
          component: BDAgent2,
          meta: {
            title: '赛事管家'
          }
        },
        {
          path: 'price-notice',
          name: 'PriceNotice',
          component: PriceNotice,
          meta: {
            title: '视频价格体系变动通知'
          }
        }
      ]
    },
    {
      path: '/group-buy',
      name: 'GroupBuy',
      component: GroupBuy,
      meta: {
        title: '装备团购'
      }
    },
    {
      path: '/live-service',
      name: 'LiveService',
      component: LiveService,
      meta: {
        title: '视频拍摄服务'
      }
    },
    {
      path: '/official-website',
      name: 'officialWebsite',
      component: OfficialWebsite,
      meta: {
        title: '关于邦教练'
      }
    },
    {
      path: '/live-cut',
      name: 'LiveCut',
      component: LiveCut,
      meta: {
        title: '有镜头'
      }
    },
    {
      path: '/official-success',
      name: 'officialSuccess',
      component: OfficialSuccess,
      meta: {
        title: '提交成功'
      }
    },
    {
      path: '/online-cash-instructions',
      name: 'onlineCashInstructions',
      component: OnlineCashInstructions,
      meta: {
        title: '开通线上收银'
      }
    },
    {
      path: '/reservation',
      name: 'Reservation',
      component: Reservation,
      meta: {
        title: '预约申请'
      }
    },
    {
      path: '/live-score',
      name: 'LiveScore',
      component: LiveScore,
      meta: {
        title: '比赛直播'
      }
    },
    {
      path: '/team-stats',
      name: 'teamStats',
      component: teamStats,
      meta: {
        title: '比赛数据'
      }
    },
    {
      path: '/official-eventLink',
      name: 'officialEventLink',
      component: officialEventLink,
      meta: {
        title: '赛事通'
      }
    },
    {
      path: '/official-coachBond',
      name: 'officialCoachBond',
      component: officialCoachBond,
      meta: {
        title: '邦教练'
      }
    },
    {
      path: '/official-smartVenues',
      name: 'officialSmartVenues',
      component: officialSmartVenues,
      meta: {
        title: '智慧场馆'
      }
    },
    {
      path: '/official-athleticAssociation',
      name: 'officialAthleticAssociation',
      component: officialAthleticAssociation,
      meta: {
        title: '邦协会'
      }
    },
    {
      path: '/official-youth',
      name: 'officialYouth',
      component: officialYouth,
      meta: {
        title: '邦少年'
      }
    },
    {
      path: '/404',
      name: '404',
      component: ErrorPage,
      meta: {
        title: '404页面'
      }
    },
    {
      path: '/service-contact',
      name: 'ServiceContact',
      component: serviceContact,
      meta: {
        title: '业务咨询'
      }
    },
    { path: '*', redirect: '/official-website' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js